import Layout from '@layouts/Layout'
import Pricing from '@screens/Pricing'

import React, { memo } from 'react'

const title = 'Pricing'
const description = 'See available pricing plans for Traqq, the time tracking tool that helps you track work hours, monitor employee activity, and improve work processes.'

const PricingPage = () => {
  return (
    <Layout
      title={title}
      description={description}
    >
      <Pricing />
    </Layout>
  )
}

export default memo(PricingPage)
